import React from 'react'
import ReactDOM from 'react-dom/client'
import PageList from '@/PageList.jsx'
import '@/index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <PageList />
  </React.StrictMode>
)
